export default {
    parts: [],
    baseStyle: (props) => ({
        wrapper: {
            position: 'relative'
        },
        container: {
            position: props?.imageIsConfigured ? props?.position : 'static',
            zIndex: '1',

            // Default or bottom/left alignment
            ...((props?.Alignment === "" || props?.Alignment === "bottom/left") && props?.position !== 'static' && {
                bottom: { base: 0 },
                left: { base: 0 },
                textAlign: { base: 'left' },
                paddingBottom: { base: '75px' },
            }),

            /* bottom/center */
            ...(props?.Alignment === "bottom/center" && props?.position !== 'static' && {
                bottom: { base: 0 },
                left: { base: '50%' },
                transform: { base: 'translateX(-50%)' },
                textAlign: { base: 'center' },
                paddingBottom: { base: '75px' },
            }),

            /* bottom/right */
            ...(props?.Alignment === "bottom/right" && props?.position !== 'static' && {
                bottom: { base: 0 },
                right: { base: 0 },
                textAlign: { base: 'right' },
                paddingBottom: { base: '75px' },
            }),

            /* center/right */
            ...(props?.Alignment === "center/right" && props?.position !== 'static' && {
                top: { base: '50%' },
                right: { base: 0 },
                transform: { base: 'translate(0, -50%)' },
                textAlign: { base: 'right' },
            }),

            /* top/right */
            ...(props?.Alignment === "top/right" && props?.position !== 'static' && {
                top: { base: 0 },
                right: { base: 0 },
                textAlign: { base: 'right' },
                paddingTop: { base: 6 },
            }),

            /* top/center */
            ...(props?.Alignment === "top/center" && props?.position !== 'static' && {
                top: { base: 0 },
                left: { base: '50%' },
                transform: { base: 'translate(-50%, 0)' },
                textAlign: { base: 'center' },
                paddingTop: { base: 6 },
            }),

            /* top/left */
            ...(props?.Alignment === "top/left" && props?.position !== 'static' && {
                top: { base: 0 },
                left: { base: 0 },
                textAlign: { base: 'left' },
                paddingTop: { base: 6 },
            }),

            /* center/center */
            ...(props?.Alignment === 'center/center' && props?.position !== 'static' && {
                textAlign: { base: 'center' },
                top: { base: '50%' },
                left: { base: '50%' },
                transform: { base: 'translate(-50%, -50%)' }
            }),

            paddingLeft: { base: 4, lg: 6 },
            paddingRight: { base: 4, lg: 6 },
            width: props?.PanelCtaBlockWidth && props?.PanelCtaBlockWidth !== '' ? props?.PanelCtaBlockWidth : 'max-content',
            maxWidth: '100%',

            ...(!props?.imageIsConfigured && {
                width: '100%',
                padding: 0
            })
        },
        preTitleStyle: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '100%' },
            marginBottom: { base: 2 }
        },
        titleStyle: {
            fontSize: { base: '32px' },
            lineHeight: { base: '100%' },
            fontWeight: { base: 'bold' },
            ...(props?.TitleShadowEffect && {
                textShadow: '0px 4px 13px rgb(0 0 0 / 0.5)'
            })
        },
        descriptionStyle: {
            fontWeight: 'normal',
            fontSize: { base: '16px', lg: '20px' },
            lineHeight: { base: '100%' },
            marginTop: { base: 3 },
            width: props?.PanelCtaBlockWidth || 'auto',
            maxWidth: '100%'
        },
        disclaimerStyle: {
            fontWeight: 'normal',
            fontSize: { base: '12px', lg: '14px' },
            lineHeight: { base: '100%' },
            marginTop: { base: 3 }
        },
        ctasWrapper: {
            display: { base: 'flex' },
            alignItems: { base: 'center' },
            justifyContent: {
                base: props?.Alignment?.includes('left') ? 'flex-start' :
                    props?.Alignment?.includes('center') ? 'center' :
                        props?.Alignment?.includes('right') ? 'flex-end' :
                            'flex-start'
            },
            gap: { base: 2 },
            flexWrap: 'wrap',
            marginTop: { base: 4 }
        },
        ctaStyling: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '100%' },
            letterSpacing: { base: '2%' },
            paddingTop: {base: 1},
            paddingBottom: {base: 1},
            paddingLeft: { base: 8, lg: 10 },
            paddingRight: { base: 8, lg: 10 },
            height: { base: 'auto' },
            minHeight: { base: '42px' },
            cursor: { base: 'pointer' },
            letterSpacing: '0%',
            _hover: {
                textDecoration: 'none',
                backgroundColor: 'charcoal',
                color: 'white'
            },
            _active: {
                backgroundColor: 'charcoal',
                color: 'white'
            },
            '@supports (-webkit-appearance: none) and (stroke-color: transparent)': {
                paddingTop: 1,
                paddingBottom: 1
            },
            // For macOS Chrome
            '.is-mac-chrome &': {
                paddingTop: '0',
                paddingBottom: '0'
            }
        },
        textStyling: {
            fontSize: { base: 'md' },
            fontWeight: { base: 'bold' },
            lineHeight: { base: '20px' }
        },
        ctaText: {
            lineHeight: '0',
            paddingTop: '0.25em',
            paddingBottom: '0.5em',
            // Safari
            ...(props?.isSafari && {
                paddingTop: '0.55em',
                paddingBottom: '0.20em'
            }),
            // Safari on iOS
            ...(props?.isSafari && props?.isIOS && {
                paddingTop: '0.6em',
                paddingBottom: '0.20em'
            }),
            // Other browsers except Safari on ioOS and macOS or android
            ...(((!props?.isSafari && (props?.isIOS || props?.isMacOS)) || props?.isAndroid) && {
                paddingTop: '0.4em',
                paddingBottom: '0.4em'
            }),
            // MacOS and Chrome
            ...(props?.isMacOSChrome && {
                paddingTop: '0.5em',
                paddingBottom: '0.36em'
            }),
        }
    })
}
